import { createCtx } from '@reatom/core';

export const ctx = createCtx();
